import IslamicContentHome from "../IslamicContentHome/IslamicContentHome";

const IslamicSubSection = (props) => {
    return (
        <IslamicContentHome id={props.id}/>
    )
}

export default IslamicSubSection;